import axios from '../http'

function query(data) {
    return axios.post('/sys/release/query', data);
}

function get(id) {
    return axios.get('/sys/release/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/release/add', data);
}

function update(data) {
    return axios.post('/sys/release/update', data);
}
function delByIds(data) {
    return axios.post('/sys/release/delByIds', data);
}

export default {
    query,
    get,
    add,
    update,
    delByIds

}